// src/components/rbac/PermissionManager.jsx
import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import {
  GET_PERMISSIONS,
  ADD_PERMISSION,
  DELETE_PERMISSION,
} from "../../graphql/rbac";

export default function PermissionManager() {
  const { data, loading, refetch } = useQuery(GET_PERMISSIONS, {
    fetchPolicy: "network-only",
  });
  const [addPermission] = useMutation(ADD_PERMISSION);
  const [deletePermission] = useMutation(DELETE_PERMISSION);

  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");

  const permissions = data?.getPermissions?.permissions || [];

  const handleAdd = async () => {
    if (!code.trim()) return alert("Permission code required");
    const res = await addPermission({
      variables: { data: { code: code.trim(), description } },
    });
    if (res?.data?.addPermission?.status === "SUCCESS") {
      setCode("");
      setDescription("");
      refetch();
    } else {
      alert(res?.data?.addPermission?.message || "Failed");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete permission?")) return;
    const res = await deletePermission({ variables: { data: { id } } });
    if (res?.data?.deletePermission?.status === "SUCCESS") {
      refetch();
    } else {
      alert(res?.data?.deletePermission?.message || "Failed");
    }
  };

  return (
    <div className="text-white">
      <div className="grid grid-cols-3 gap-4 mb-6">
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Permission code (eg: bookings.verify)"
          className="p-2 bg-[#0c0b0b] rounded"
        />
        <input
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
          className="p-2 bg-[#0c0b0b] rounded"
        />
        <button
          onClick={handleAdd}
          className="bg-[#FBB034] px-4 py-2 rounded font-bold"
        >
          Add Permission
        </button>
      </div>

      {loading ? (
        <p className="text-gray-400">Loading permissions...</p>
      ) : (
        <div>
          {permissions.length === 0 ? (
            <p className="text-gray-400">No permissions</p>
          ) : (
            <ul className="space-y-2">
              {permissions.map((p) => (
                <li
                  key={p.id}
                  className="flex items-center justify-between bg-[#0c0b0b] p-3 rounded"
                >
                  <div>
                    <div className="font-semibold text-[#FBB034]">{p.code}</div>
                    <div className="text-sm text-gray-300">{p.description}</div>
                  </div>
                  <button
                    onClick={() => handleDelete(p.id)}
                    className="text-red-500 px-3 py-1 rounded border border-red-500"
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
